import { createIcon } from '@chakra-ui/react';

export const CloudRVRDisabled = createIcon({
  displayName: 'CloudRVRDisabled',
  viewBox: '0 0 24 24',
  path: [
    <path
      d="M20 19.6C20 19.4 20 19.2 20.2 19.2C20.4 18.8 20.8 18.6 21.2 18.8L23.4 20.2L20 23.6V19.6Z"
      fill="currentColor"
    />,
    <path
      d="M8.6 34.8L7.2 36.2C5.4 34.8 4 32.4 4 29.8C4 26 6.6 22.8 10 22C10.4 15.2 16 9.8 23 9.8C26 9.8 28.8 10.8 31 12.6L29.6 14C27.6 12.6 25.4 11.8 23 11.8C17.2 11.8 12.4 16.4 12 22.2V23.6L10.6 24C7.8 24.6 6 27 6 29.8C6 31.8 7 33.6 8.6 34.8Z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 17.8C40 18.4 44 22.6 44 27.6C44 33.2 39.4 37.6 34 37.6H11.4L7.4 41.6C7 42 6.4 42 6 41.6C5.6 41.2 5.6 40.6 6 40.2L9.2 37.2L38.6 7.8C39 7.4 39.6 7.4 40 7.8C40.4 8.2 40.4 8.8 40 9.2L33.6 15.4C34.2 16.2 34.6 17 35 17.8ZM13.4 35.8H34C38.4 35.8 42 32.2 42 28.2C42 24 38.8 20.6 34.8 20.2L33.6 20L33.2 18.8C33 18.5 32.85 18.2 32.7 17.9C32.55 17.6 32.4 17.3 32.2 17L26.8 22.4L29.6 24.2C29.6 24.2 29.8 24.2 29.8 24.4C30 24.6 30 25.2 29.6 25.4L21.2 30.6C21 30.8 21 30.8 20.8 30.8C20.4 30.8 20 30.4 20 30V29.2L13.4 35.8Z"
      fill="currentColor"
    />,
  ],
});
